
import { apiFetch } from "../_utils/apiInterceptor.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${backendUrl}/api/v1/invoices`;
  
export const get = async (tenantId) => {
  return await apiFetch(
    `${BASE_URL}/?tenantId=${tenantId}`, {
    method: 'GET'
  });
};  
